import React from 'react';

export default class GroupBtn extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            minutes: this.props.time_to_do,
            seconds: 0,
            spend_time: 0
        }
    }

    async componentDidMount() {
        this.myInterval = setInterval(() => {
            const { seconds, minutes, spend_time } = this.state;
            if(minutes == 0 && seconds == 0){
                this.handleSubmit();
            }
            this.setState({spend_time: spend_time + 1})
            if (seconds > 0) {
                this.setState(({ seconds }) => ({
                    seconds: seconds - 1
                }))
            }
            if (seconds === 0) {
                if (minutes === 0) {
                    clearInterval(this.myInterval)
                } else {
                    this.setState(({ minutes }) => ({
                        minutes: minutes - 1,
                        seconds: 59
                    }))
                }
            }
        }, 1000)
    }

    componentWillUnmount() {
        clearInterval(this.myInterval)
    }

    convertString(text){
        text = text + "";
        if(text.length<2){
            text = "0"+text;
        }
        return text
    }
    handleSubmit = () => {
        const self = this;
        const {seconds, minutes,spend_time} = this.state;
        if(minutes == 0 && seconds == 0){
            alert("Đã hết giờ làm bài!");
            setTimeout(function() { self.props.handleSubmit(spend_time); return false; }, 0);
        }else {
            if(window.confirm('Bạn có chắc muốn nộp bài?')){
                self.props.handleSubmit(spend_time);
            }else {
                return false;
            }
        }
    }

    render(){
        const {index_question_active,total_question} = this.props;
        return(
            <div className="btnControl">
                {index_question_active != 0 && index_question_active != total_question - 1 &&
                <a  className="btnShowHide" onClick={this.props.previousQuestion}><span style={{fontSize: "20px",lineHeight:"15px",marginRight:"10px"}}> &lsaquo; </span> Câu hỏi trước</a>}
                {index_question_active != total_question - 1 ?
                <a className="btnShowHide" onClick={this.props.nextQuestion}>Câu hỏi tiếp theo <span style={{fontSize: "20px",lineHeight:"15px",marginLeft:"10px"}}>&rsaquo;</span></a> :
                <a className="btnShowHide" style={{ background: "#df7100", color: "#fff" }} onClick={this.handleSubmit}>NỘP BÀI</a>
                }
            </div>
        );
    }
}
